

import LazyLoad from 'react-lazyload';

import withTheme from 'utils/hocs/withTheme';

const StreamingWrapper = ({
  theme,
  children
}) => (
  <>
    {/* TODO: double check if we really need LazyLoad */}
    <LazyLoad height={500}>
      <div className='streaming-wrapper'>
        {children}
      </div>
    </LazyLoad>
    <style jsx>{`
      .streaming-wrapper {
        display: grid;
        grid-template-columns: 100%;
        max-width: 120rem;
        margin: 0 auto;
        margin-bottom: 7rem;
      }

      @media ${theme.mediaQueries.largest} {
        .streaming-wrapper {
          max-width: 105rem;
        }
      }

      @media ${theme.mediaQueries.larger} {
        .streaming-wrapper {
          max-width: 110rem;
          margin-bottom: 6rem;
        }
      }

      @media ${theme.mediaQueries.large} {
        .streaming-wrapper {
          max-width: 110rem;
          margin-bottom: 5rem;
        }
      }

      @media ${theme.mediaQueries.medium} {
        .streaming-wrapper {
          display: block;
          grid-template-columns: unset;
          margin-bottom: 5rem;
        }
      }
    `}</style>
  </>
);

export default withTheme(StreamingWrapper);
